import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setFieldWidth: YJSChangeHandler<DatabaseChangeType.SET_FIELD_WIDTH> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    db.fieldsById[change.fieldId].width = change.width;
  });
};
